import { useContext, useEffect, useState } from "react";
import classes from '../screens/game/game-styles.module.css'
import TimerContext from "../store/timerState/timer-context";
const Timer = (props) => {
    const timerCtx = useContext(TimerContext);
    let timeout
    const { chose } = props
    useEffect(() => {
        console.log(timerCtx.timer);
        if (timerCtx.timer >= 0 && !chose) {
            timeout = setTimeout(() =>
                timerCtx.countDown(), 1000);
        }
        else if (chose) { // user chosen an answer
            timerCtx.resetTimer()
            clearTimeout(timeout)
        }
        else if (timerCtx.timer <= 0) {  // user didn't chose an answer and timeout
            props.onTimeOut()
            timerCtx.resetTimer()
            return (
                clearTimeout(timeout)
            )
        }
    }, [timerCtx.timer, chose]);

    return (
        <div className={classes.counter}>
            <h6 className={classes.timer}>00:{timerCtx.timer}</h6>
        </div>
    )
}
export default Timer;